// extracted by mini-css-extract-plugin
export default {"Button":"Buttons-module-e8e7661f5a83b8ef4ec5"};